function CommentsLsDOMDisplay() {
    return {
        fieldShow(field) {
            field.closest(".field-comment").removeClass("hide");
            field.closest(".field-comment").addClass("show");
        },

        fieldHide(field) {
            field.closest(".field-comment").removeClass("show");
            field.closest(".field-comment").addClass("hide");
        },

        show(element) {
            element.removeClass("hide");
            element.addClass("show");
        },

        hide(element) {
            element.removeClass("show");
            element.addClass("hide");
        }
    }
}
